module.exports = __webpack_public_path__ + "img/left_hand.ed13f863.png";